import React from 'react'
import Layout from '../../components/Layout'

const AttributesPage = () => {
    return (
        <React.Fragment>
            AttributesPage
        </React.Fragment>
    )
}

export default AttributesPage
